import React from 'react'
import "./index.scss"
export const TextSimulation = () => {
  return (
    <div className='TextSimulation-container mt-5'><h1 className='TextSimulation-title'>Pourquoi faire une <br/>simulation ?</h1>
    <p className='TextSimulation-text' >Parce qu’avant d’agir, il faut comprendre </p></div>
  )
}
